module.exports = __webpack_public_path__ + "static/img/actor-not-found-2.6980d19.png";